import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Visualization from './pages/Visualization';
import About from './pages/About';
import Home from './pages/Home';
import Profile from './pages/Profile';
import { FirebaseProvider } from './context/FirebaseContext';
import { VisualizationProvider } from './context/VisualizationContext';
import { InstallFlyerProvider } from './components/InstallFlyer';
import UpdateBanner from './components/UpdateBanner';
import RouteMemory from './components/RouteMemory';

function App() {
  return (
    <>
      <FirebaseProvider>
        <VisualizationProvider>
          <InstallFlyerProvider>
            <Router>
              <RouteMemory />
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/artist/:artistId" element={<Visualization />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/visualization" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </Router>
          </InstallFlyerProvider>
        </VisualizationProvider>
      </FirebaseProvider>

      <UpdateBanner />
    </>
  );
}

export default App;
